import "./recommendation_rule_effect_name.js";
//#region src/recommendation_rule_effect_name_helper.ts
let RecommendationRuleEffectNameHelper;
(function(_RecommendationRuleEffectNameHelper) {
	function name(recommendationEffectName) {
		switch (recommendationEffectName) {
			case "do-not-recommend-items": return "Do not recommend items";
			case "do-not-recommend-items-in-cart": return "Do not recommend items in cart";
			case "do-not-recommend-items-in-same-section-in-cart": return "Do not recommend items in same section in cart";
			case "do-not-recommend-items-in-same-section-as-selected-item": return "Do not recommend items in same section as selected item";
			case "do-not-recommend-items-in-section": return "Do not recommend items in section";
			case "do-not-recommend-selected-item": return "Do not recommend selected item";
			case "do-not-recommend-alcoholic-or-other-menu-category-items": return "Do not recommend alcoholic or other menu category items";
			case "do-not-recommend-zero-price-items": return "Do not recommend items with $0 price";
			case "heuristics-v2": return "Heuristics v2";
			case "recommend-items": return "Recommend items";
			case "recommend-modifiers": return "Recommend modifiers";
			case "recommend-items-in-section": return "Recommend items in section";
			case "recommend-guest-previously-ordered-items": return "Recommend guest previously ordered items";
			case "recommend-guest-favorite-items": return "Recommend guest favorite items";
			case "recommend-guest-predictions-on-previously-ordered-items": return "Recommend guest predictions on previously ordered items";
			case "sort-items-in-section": return "Sort items in section";
			case "sort-items-in-sections-randomly": return "Sort items in sections randomly";
			case "menu-item-affinity": return "Menu Item Affinity";
			case "menu-item-affinity-magic-copy-key": return "Menu Item Affinity Magic Copy Key";
			case "do-not-recommend-items-with-dietary-restriction": return "Do not recommend items with dietary restriction";
			case "recommend-items-from-prefered-category": return "Recommend items from preferred category";
			case "recommend-only-items-with-dietary-preference": return "Recommend only items with dietary preference";
		}
	}
	_RecommendationRuleEffectNameHelper.name = name;
	function isGuestHistoryEffect(recommendationEffectName) {
		return [
			"recommend-guest-previously-ordered-items",
			"recommend-guest-favorite-items",
			"recommend-guest-predictions-on-previously-ordered-items"
		].includes(recommendationEffectName);
	}
	_RecommendationRuleEffectNameHelper.isGuestHistoryEffect = isGuestHistoryEffect;
})(RecommendationRuleEffectNameHelper || (RecommendationRuleEffectNameHelper = {}));
//#endregion
export { RecommendationRuleEffectNameHelper };

//# sourceMappingURL=recommendation_rule_effect_name_helper.js.map